import {path} from './urls/conf';
import {init as initArchivedProjectList} from './views/archivedprojectlist';
import {init as initDealCalc} from './views/dealcalc';
import {init as initDealDiscovery} from './views/dealdiscovery';
import {init as initDealProfile} from './views/dealprofile';
import {init as initDoNotMail} from './views/donotmail';
import {init as initGeneral} from './views/general';
import {init as initPriceCreate} from './views/pricecreate';
import {init as initPriceUpdate} from './views/priceupdate';
import {init as initParcelDetail} from './views/parceldetail';
import {init as initProjectList} from './views/projectlist';
import {init as initProjectDetail} from './views/projectdetail';
import {RequestHandler} from './urls/handlers';
import {ResolverMatch} from './urls/resolvers';

const urlPatterns = [
	path(/^account\/archive\//, initArchivedProjectList),
	path(/^account\/do-not-mail\//, initDoNotMail),
	path(/^account\//, initGeneral),
	path(/^password-reset\//, initGeneral),
	path(/^sign-in\//, initGeneral),
	path(/^dashboard\/users\//, initGeneral),
	path(/^dashboard\/coupons\//, initGeneral),
	path(/^dashboard\/prices\/(\d+)\/update\//, initPriceUpdate),
	path(/^dashboard\/prices\/create\//, initPriceCreate),
	path(/^dashboard\/prices\//, initGeneral),
	// Deal Profiles (Phase 5C) — must precede the deal-editor pattern so
	// /deals/profiles/<slug>/ doesn't slug-match into the deal editor.
	path(/^deals\/profiles\/?$/, initDealProfile),
	path(/^deals\/profiles\/onboarding\/?$/, initDealProfile),
	path(/^deals\/profiles\/new\/?$/, initDealProfile),
	path(/^deals\/profiles\/([A-Za-z0-9]{5})\/?$/, initDealProfile),
	path(/^deals\/?$/, initDealCalc),
	path(/^deals\/new\/?$/, initDealCalc),
	// Variable-length cohort compare (Phase 5E): 2-6 deal slugs in the
	// path. Single capture group on the slugs tail; the view module
	// reads them from the rendered `data-deal-slugs` attribute, so we
	// don't need each slug as a separate capture group.
	path(/^deals\/compare\/(?:[A-Za-z0-9]{5}\/){2,6}$/, initDealCalc),
	path(/^deals\/([A-Za-z0-9]{5})\/?$/, initDealCalc),
	// Parcel detail (Phase 3a) — the first parcel-shaped surface
	// outside any project context. UUID-shaped capture so the
	// catch-all project-detail pattern below can't shadow it.
	path(/^parcels\/([A-Fa-f0-9-]+)\/?$/, initParcelDetail),
	// Project-scoped Deal Calc routes (Phase 5B). Must come before the
	// project-detail catch-all so /<5-char>/deals/... dispatches into
	// the deal calc bundle, not project detail.
	path(/^([A-Z0-9]{5})\/deals\/?$/, initDealCalc),
	path(/^([A-Z0-9]{5})\/deals\/new\/?$/, initDealCalc),
	path(/^([A-Z0-9]{5})\/deals\/([A-Za-z0-9]{5})\/?$/, initDealCalc),
	path(/^([A-Z0-9]{5})\/discover\/?$/, initDealDiscovery),
	path(/^([A-Z0-9]{5})\//, initProjectDetail),
	path(/^$/, initProjectList),
];
const handler = new RequestHandler();
const req = {pathname: window.location.pathname, urlPatterns};
let match: ResolverMatch | undefined = undefined;
try {
	match = handler.resolveRequest(req);
} catch {
}
if (match) {
	match.func.call(this, ...match.args);
}
